export const GATEKEEPER_ENDPOINTS = {
    "userpersonalisation": {
        "age": 300,
        "path": ['userpersonalisation', '/v##']
    },
    "getmycourses": {
        "age": 120,
        "path": ['mycourses', '/v##']
    },
    "getallmessages": {
        "age": 900,
        "path": ['mymessages', '/v##/all']
    },
    "setmessage": {
        "age": 7200,
        "path": ['mymessages', '/v##', '/##', '/##']
    },
    "getallstorage": {
        "age": 7200,
        "path": ['storage', '/v##']
    },
    "setallstorage": {
        "age": 7200,
        "path": ['storage', '/v##']
    },
    "getimagekeys": {
        "age": 1,
        "path": ['photostore', '/v##/keys']
    },
    "getmydetails": {
        "age": 120,
        "path": ['mydetails', '/v##']
    },
    "getmyschedule": {
        "age": 120,
        "path": ['myschedule', '/v##']
    },
    "getmyresults": {
        "age": 7200,
        "path": ['myresults', '/v##']
    },
    "getmyfees": {
        "age": 120,
        "path": ['myfees', '/v##']
    },
    "getmyfeesv2": {
        "age": 120,
        "path": ['myfees', '/v##']
    },
    "getmyresearch": {
        "age": 7200,
        "path": ['myresearch', '/v##']
    },
    "getmytasks": {
        "age": 900,
        "path": ['mytasks', '/v##', '/##']
    },
    "getmytaskspercent": {
        "age": 20,
        "path": ['mytasks', '/v##', '/##', '/##']
    },
    "getjourneypercent": {
        "age": 20,
        "path": ['mytasks', '/v##', '/##', '/##']
    },
    "setcoursecolours": {
        "age": 7200,
        "path": ['storage', '/v##', '/coursecolours']
    },
    "setpollscomplete": {
        "age": 7200,
        "path": ['storage', '/v##', '/pollscomplete']
    },
    "getmychecklist": {
        "age": 900,
        "path": ['mychecklist', '/v##']
    },
    "getmynegativeserviceindicator": {
        "age": 900,
        "path": ['mynegativeserviceindicator', '/v##']
    }
};

export const GSP_DATA_COLOUR_SCHEMES = [
    { "name": "green", "code": "#417700" },
    { "name": "orange", "code": "#af5d00" },
    { "name": "blue", "code": "#006495" },
    { "name": "pink", "code": "#bf007e" },
    { "name": "purple", "code": "#631e83" },
    { "name": "red", "code": "#cc3100" },
    { "name": "green", "code": "#417700" },
    { "name": "orange", "code": "#af5d00" },
    { "name": "blue", "code": "#006495" },
    { "name": "pink", "code": "#bf007e" },
    { "name": "purple", "code": "#631e83" },
    { "name": "red", "code": "#cc3100" }
];

export const GSP_DATA_TILES = [
    {
        id: "763582",
        name: "Orientation event check-in - Arts, Education and Law",
        short_name: "First trimester - O'week - AEL",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"]},"weight":991,"restrict":"Must"},{"attr":{"AFFILIATION":["OUA","GELI","PEARSON"]},"restrict":"Not"},{"attr":{"AVAILABLE_DATE":{"from":"2019-06-30T14:00:00.000Z","to":"2019-07-07T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2019-10-20T14:00:00.000Z","to":"2014-10-27T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-02-16T14:00:00.000Z","to":"2020-02-23T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-06-28T14:00:00.000Z","to":"2020-07-05T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-10-18T14:00:00.000Z","to":"2020-10-25T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"ORIENT_ACAD_GROUP":"ARG"},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-hourglass-start",
        classname: "welcome-to-griffith",
        color: "aqua",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/students/myorientation-assets/orientation-checkin-ael",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>Register your attendance at your school's orientation event.</p> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "sq-icon__collaborative-zone"



    }
    , {
        id: "763578",
        name: "Orientation event check-in - Griffith Business School",
        short_name: "First trimester - O'week - GBS",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"]},"weight":991,"restrict":"Must"},{"attr":{"AFFILIATION":["OUA","GELI","PEARSON"]},"restrict":"Not"},{"attr":{"AVAILABLE_DATE":{"from":"2019-06-30T14:00:00.000Z","to":"2019-07-07T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2019-10-20T14:00:00.000Z","to":"2014-10-27T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-02-16T14:00:00.000Z","to":"2020-02-23T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-06-28T14:00:00.000Z","to":"2020-07-05T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-10-18T14:00:00.000Z","to":"2020-10-25T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"ORIENT_ACAD_GROUP":"BUS"},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-hourglass-start",
        classname: "welcome-to-griffith",
        color: "aqua",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/students/myorientation-assets/orientation-checkin-gbs",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>Register your attendance at your school's orientation event.</p> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "sq-icon__collaborative-zone"



    }
    , {
        id: "763574",
        name: "Orientation event check-in - Griffith Health",
        short_name: "First trimester - O'week - HTH",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"]},"weight":991,"restrict":"Must"},{"attr":{"AFFILIATION":["OUA","GELI","PEARSON"]},"restrict":"Not"},{"attr":{"AVAILABLE_DATE":{"from":"2019-06-30T14:00:00.000Z","to":"2019-07-07T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2019-10-20T14:00:00.000Z","to":"2014-10-27T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-02-16T14:00:00.000Z","to":"2020-02-23T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-06-28T14:00:00.000Z","to":"2020-07-05T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-10-18T14:00:00.000Z","to":"2020-10-25T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"ORIENT_ACAD_GROUP":"HTH"},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-hourglass-start",
        classname: "welcome-to-griffith",
        color: "aqua",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/students/myorientation-assets/orientation-checkin-health",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>Register your attendance at your school's orientation event.</p> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "sq-icon__collaborative-zone"



    }
    , {
        id: "763564",
        name: "Orientation event check-in - Griffith Sciences",
        short_name: "First trimester - O'week - SCG",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"]},"weight":991,"restrict":"Must"},{"attr":{"AFFILIATION":["OUA","GELI","PEARSON"]},"restrict":"Not"},{"attr":{"AVAILABLE_DATE":{"from":"2019-06-30T14:00:00.000Z","to":"2019-07-07T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2019-10-20T14:00:00.000Z","to":"2014-10-27T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-02-16T14:00:00.000Z","to":"2020-02-23T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-06-28T14:00:00.000Z","to":"2020-07-05T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-10-18T14:00:00.000Z","to":"2020-10-25T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"ORIENT_ACAD_GROUP":"SCG"},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-hourglass-start",
        classname: "welcome-to-griffith",
        color: "aqua",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/students/myorientation-assets/orientation-checkin-sciences",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>Register your attendance at your school's orientation event.</p> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "sq-icon__collaborative-zone"



    }
    , {
        id: "78300",
        name: "Get set for success",
        short_name: "First trimester - Week 1-2",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"]},"weight":991,"restrict":"Must"},{"attr":{"AFFILIATION":["OUA","GELI","PEARSON"]},"restrict":"Not"},{"attr":{"AVAILABLE_DATE":{"from":"2019-07-07T14:00:00.000Z","to":"2019-07-21T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2019-09-27T14:00:00.000Z","to":"2019-11-10T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-02-23T14:00:00.000Z","to":"2020-03-08T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-07-05T14:00:00.000Z","to":"2020-07-19T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-10-25T14:00:00.000Z","to":"2020-11-08T13:59:00.000Z"}},"restrict":"MustOR"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-hourglass-start",
        classname: "welcome-to-griffith",
        color: "aqua",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/first-trimester/setting-up-for-success",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>Check out our tips and resources to help you be your best.</p> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "sq-icon__collaborative-zone"



    }
    , {
        id: "78312",
        name: "Learning with others",
        short_name: "First trimester - Week 3-4",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"]},"weight":991,"restrict":"Must"},{"attr":{"AFFILIATION":["OUA","GELI","PEARSON"]},"restrict":"Not"},{"attr":{"AVAILABLE_DATE":{"from":"2019-07-21T14:00:00.000Z","to":"2019-08-04T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2019-11-10T14:00:00.000Z","to":"2019-11-24T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-03-08T14:00:00.000Z","to":"2020-03-22T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-07-19T14:00:00.000Z","to":"2020-08-02T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-11-08T14:00:00.000Z","to":"2020-11-22T13:59:00.000Z"}},"restrict":"MustOR"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-hourglass-half",
        classname: "welcome-to-griffith",
        color: "aqua",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/first-trimester/learning-with-others",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>University is a great place to make new friends and learn from new influences. We offer many opportunities to connect and collaborate.</p> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "sq-icon__collaborative-zone"



    }
    , {
        id: "78309",
        name: "You're almost halfway",
        short_name: "First trimester - Week 5",
        audiences: '[{"attr":{"CAREER":["UGRD","PGRD"]},"weight":991,"restrict":"Must"},{"attr":{"LIFECYCLE_STATUS":["AP","AW","CA","NE","PS","PT","UR","AL","PA"]},"restrict":"Not"},{"attr":{"AFFILIATION":["OUA","GELI","PEARSON"]},"restrict":"Not"},{"attr":{"AVAILABLE_DATE":{"from":"2019-08-04T14:00:00.000Z","to":"2019-08-18T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2019-11-24T14:00:00.000Z","to":"2019-12-01T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-03-22T14:00:00.000Z","to":"2020-03-29T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-08-02T14:00:00.000Z","to":"2020-08-16T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-11-22T14:00:00.000Z","to":"2020-11-29T13:59:00.000Z"}},"restrict":"MustOR"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-hourglass-half",
        classname: "welcome-to-griffith",
        color: "aqua",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/enrich-your-studies",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>Stay active and save room for fun. You can also sink your teeth into a range of extra-curricular activities to enrich your studies.</p> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "sq-icon__collaborative-zone"



    }
    , {
        id: "78329",
        name: "Maintain momentum",
        short_name: "First trimester - Week 6-7",
        audiences: '[{"attr":{"CAREER":["UGRD","PGRD"]},"weight":991,"restrict":"Must"},{"attr":{"LIFECYCLE_STATUS":["AP","AW","CA","NE","PS","PT","UR","AL","PA"]},"restrict":"Not"},{"attr":{"AFFILIATION":["OUA","GELI","PEARSON"]},"restrict":"Not"},{"attr":{"AVAILABLE_DATE":{"from":"2019-08-18T14:00:00.000Z","to":"2019-09-01T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2019-12-01T14:00:00.000Z","to":"2019-12-15T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-03-29T14:00:00.000Z","to":"2020-04-19T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-08-16T14:00:00.000Z","to":"2020-08-30T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-11-29T14:00:00.000Z","to":"2020-12-13T13:59:00.000Z"}},"restrict":"MustOR"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-hourglass-half",
        classname: "welcome-to-griffith",
        color: "aqua",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/tutoring",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>It's important to keep going to your lectures and tutorials, as it can really help you succeed. Reach out to a tutor if you need extra help.</p>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "sq-icon__collaborative-zone"



    }
    , {
        id: "78322",
        name: "The home stretch",
        short_name: "First trimester - Week 8-9",
        audiences: '[{"attr":{"CAREER":["UGRD","PGRD"]},"weight":991,"restrict":"Must"},{"attr":{"LIFECYCLE_STATUS":["AP","AW","CA","NE","PS","PT","UR","AL","PA"]},"restrict":"Not"},{"attr":{"AVAILABLE_DATE":{"from":"2019-09-01T14:00:00.000Z","to":"2019-09-15T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2019-12-15T14:00:00.000Z","to":"2020-01-12T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-04-19T14:00:00.000Z","to":"2020-05-03T02:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-08-30T14:00:00.000Z","to":"2020-09-13T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-12-13T14:00:00.000Z","to":"2021-01-10T13:59:00.000Z"}},"restrict":"MustOR"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-hourglass-end",
        classname: "welcome-to-griffith",
        color: "aqua",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/student-services/counselling-wellbeing/helpful-resources",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>Stay focussed and look after your mental and physical health. We have plenty of resources to assist.</p> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "sq-icon__collaborative-zone"



    }
    , {
        id: "78326",
        name: "The  final countdown",
        short_name: "First trimester - Week 10-12",
        audiences: '[{"attr":{"CAREER":["UGRD","PGRD"]},"weight":991,"restrict":"Must"},{"attr":{"LIFECYCLE_STATUS":["AP","AW","CA","CM","NE","PS","PT","UR","AL","PA"]},"restrict":"Not"},{"attr":{"AVAILABLE_DATE":{"from":"2019-09-15T14:00:00.000Z","to":"2019-10-06T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-01-12T14:00:00.000Z","to":"2020-02-02T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-05-03T14:00:00.000Z","to":"2020-05-24T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-09-13T14:00:00.000Z","to":"2020-10-04T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2021-01-10T14:00:00.000Z","to":"2021-01-31T13:59:00.000Z"}},"restrict":"MustOR"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-hourglass-end",
        classname: "welcome-to-griffith",
        color: "aqua",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/students/assessment-exams-grades",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>Stay positive and finish strong with our handy guide to exams and assignments. Remember you can access counselling services, as well as self-help resources at any time.</p>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "sq-icon__collaborative-zone"



    }
    , {
        id: "78336",
        name: "Beyond assessments",
        short_name: "First trimester - Week 13",
        audiences: '[{"attr":{"CAREER":["UGRD","PGRD"]},"weight":991,"restrict":"Must"},{"attr":{"LIFECYCLE_STATUS":["AP","AW","CA","CM","NE","PS","PT","UR","AL","PA"]},"restrict":"Not"},{"attr":{"AVAILABLE_DATE":{"from":"2019-10-06T14:00:00.000Z","to":"2019-10-20T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2019-02-02T14:00:00.000Z","to":"2019-02-16T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-05-24T14:00:00.000Z","to":"2020-06-28T13:59:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2020-10-04T14:00:00.000Z","to":null}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2021-01-31T14:00:00.000Z","to":"2021-02-14T13:59:00.000Z"}},"restrict":"MustOR"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-hourglass",
        classname: "welcome-to-griffith",
        color: "aqua",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/first-trimester/beyond-your-first-trimester",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>Congratulations on completing the trimester! Celebrate your achievements and focus on your future with these activities, tips and tools.</p> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "sq-icon__collaborative-zone"



    }
    , {
        id: "486085",
        name: "Report a concern",
        short_name: "Report a concern",
        audiences: '[]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-comments",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/safe-campuses",
        click_event: "",
        contents: "<p>Griffith is committed to providing safe and inclusive campus communities, free from harassment, bullying, discrimination and assault and encourage members of the Griffith community to report when these behaviours occur.</p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "51101",
        name: "Open Universities Australia",
        short_name: "Open Universities Australia",
        audiences: '[{"attr":{"AFFILIATION":["OUA"]},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-university",
        classname: "Open Universities Australia",
        color: "aqua",
        widths: ["m", "t", "d"],
        url: "http://www.open.edu.au",
        click_event: "",
        contents: " <div id='content_div_715230'> Access Open Universities Australia online resources.  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "51070",
        name: "Griffith OUA",
        short_name: "Griffith OUA",
        audiences: '[{"attr":{"AFFILIATION":["OUA"]},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "sq-icon__collaborative-zone",
        classname: "welcome-to-griffith-OUA",
        color: "blue-grey-light",
        widths: ["m", "t", "d"],
        url: "http://www.griffith.edu.au/open-universities-australia",
        click_event: "",
        contents: " <div id='content_div_715230'> Hey {{ userpersonalisation.attributes.NAME }}, explore the resources available to you at Griffith OUA.  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "sq-icon__collaborative-zone"



    }
    , {
        id: "51080",
        name: "OUA Degree Registration",
        short_name: "OUA Degree Registration",
        audiences: '[{"attr":{"AFFILIATION":["OUA"]},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-graduation-cap",
        classname: "OUA-degree-registraion",
        color: "green",
        widths: ["m", "t", "d"],
        url: "http://www.griffith.edu.au/open-universities-australia/degree-registration",
        click_event: "",
        contents: " <div id='content_div_715230'> Academic credit / Recognition of prior learning, graduation information and important dates.  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "51074",
        name: "Study Smart",
        short_name: "OUA Study Smart",
        audiences: '[{"attr":{"AFFILIATION":["OUA"]},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-desktop",
        classname: "study-smart",
        color: "orange",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/library/study",
        click_event: "",
        contents: " <div id='content_div_715230'> This online tutorial provides you with strategies, resources and interactive learning activities designed to help you succeed in your studies.  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "72465",
        name: "Home page tiles",
        short_name: "Staff information tile",
        audiences: '[{"attr":{"ROLE":["STUDENT"]},"restrict":"Not"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-info-circle",
        classname: "staff-information",
        color: "cornflower-blue",
        widths: ["m", "t", "d"],
        url: "https://intranet.secure.griffith.edu.au/student/mygriffith-student-support",
        click_event: "",
        contents: " <div id='content_div_718274'> Various tiles will display on the home page. These tiles will provide key information and link to the relevant site or system. The tiles will change depending on the students stage in the life cycle and type of student e.g Commencing, undergraduate etc.  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-info-circle cornflower-blue"



    }
    , {
        id: "51136",
        name: "Experience@Griffith",
        short_name: "Experience@Griffith",
        audiences: '[{"attr":{"AFFILIATION":["GELI"]},"restrict":"Not"},{"attr":{"COURSE_EVALUATIONS":true},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "tile__icon sq-icon__writing-paper",
        classname: "experience-@-griffith",
        color: "cornflower-blue",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/experience",
        click_event: "",
        contents: " <div id='content_div_720364'> <div>   <p>You have a survey to complete.&nbsp;</p>    <p>Your feedback is important and we offer<br />   cash prizes for every survey you complete.</p>    <p><span style='line-height: 1.3;'>Top prize of <strong>$1,000</strong> on offer every semester!</span></p> </div>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "no",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "51095",
        name: "Degree and Career Finder",
        short_name: "Degree and Career Finder",
        audiences: '[{"attr":{"AFFILIATION":["GUEST"]},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-search",
        classname: "future-students-high-school",
        color: "coral",
        widths: ["m", "t", "d"],
        url: "http://www.griffith.edu.au/future-students/high-school-students",
        click_event: "",
        contents: " <div id='content_div_715230'> Hey {{ userpersonalisation.attributes.NAME }}, a Griffith degree can open up a world of opportunities, explore what we have to offer.  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "667141",
        name: "BusinessPLUS",
        short_name: "BusinessPLUS (linked in HOME and EMPLOYMENT pages)",
        audiences: '[{"attr":{"SCHOOL":"GBS"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1230"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1293"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1325"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1374"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1382"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1420"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1439"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1456"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1464"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1465"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1468"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1469"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1474"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1475"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1494"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1495"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1505"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1506"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1507"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1508"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1509"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1510"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1513"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1521"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1522"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1529"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1544"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1545"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1550"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1551"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1552"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1556"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1557"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1568"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1569"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1570"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1571"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1572"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1582"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1595"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1599"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1603"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1605"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1606"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1607"},"restrict":"MustOR"},{"attr":{"PROGRAM_CODE":"1608"},"restrict":"MustOR"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-comments",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/businessplus",
        click_event: "",
        contents: "<p>Explore your career options and develop skills and experiences that will enhance your employability.&nbsp;&nbsp;BusinessPLUS provides you with a structured plan of co-curricular activities to complete over the course of your degree. Get involved now!</p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "47705",
        name: "O-Week",
        short_name: "O-Week Event planner - UGRD",
        audiences: '[{"attr":{"AFFILIATION":["OUA","GELI","PEARSON"]},"restrict":"Not"},{"attr":{"LIFECYCLE_STATUS":["CM"],"CAREER":["UGRD"]},"weight":899,"restrict":"Must"},{"attr":{"AVAILABLE_DATE":{"from":"2016-11-30T16:00:00.000Z","to":"2017-02-27T13:00:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2017-05-28T18:00:00.000Z","to":"2017-07-03T11:00:00.000Z"}},"restrict":"MustOR"},{"attr":{"AVAILABLE_DATE":{"from":"2017-09-24T18:00:00.000Z","to":"2017-10-30T11:00:00.000Z"}},"restrict":"MustOR"}]',
        linkType: "outer",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-calendar",
        classname: "event-planner",
        color: "orange",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/orientation",
        click_event: "",
        contents: "<a href='https://www.griffith.edu.au/orientation' class='tile__split'>     O-week is your chance to meet staff and students, explore the campus and find out what to expect as a Griffith student. </a> <a href='https://app.secure.griffith.edu.au/orientation/' class='tile__split'>     Create your personalised O-Week Itinerary </a>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "53542",
        name: "My Course enrolment",
        short_name: "OUA Enrolled courses",
        audiences: '[{"attr":{"AFFILIATION":["OUA"]},"weight":990,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_program_title_iframe }}",
        click_event: "",
        contents: " <div id='content_div_687018'> <p>Hi {{ userpersonalisation.attributes.NAME }}, you can view your current and historical Griffith course/unit information here.</p> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "47713",
        name: "Library",
        short_name: "Library",
        audiences: '[{"attr":{},"weight":200}]',
        linkType: "inner",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-book",
        classname: "library",
        color: "purple",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/library",
        click_event: "",
        contents: "<div>     <ul class='tile--library__actions'>         <li><a href='https://www.griffith.edu.au/library/borrowing-resources'><div class='sq-icon__book-small library__action--icon'></div>Loans and requests</a></li>         <li><a href='https://www.griffith.edu.au/library'><div class='sq-icon__browser-small library__action--icon'></div>Library website</a></li>         <li><a href='https://griffith.rl.talis.com/index.html'><div class='sq-icon__book-small library__action--icon'></div>Reading lists</a></li>     </ul> </div>  <!-- BRI_Griffith Uni_Logged In Students Beacon --> <img border='0' src='https://r.turn.com/r/beacon?b2=sveu9vQX0b9ADLeMSbTZ7KnE9cg_pZEi0myeCMnvvpkPXwSQmAmkN2wRLTEw84u-DlWayZJSQNq2fs7v2f72qA&cid='>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "49229",
        name: "Employability",
        short_name: "Employability",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CT"]},"restrict":"Must"},{"attr":{"AFFILIATION":["GELI"]},"restrict":"Not"}]',
        linkType: "inner",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-briefcase",
        classname: "shops-cafes-bars",
        color: "cornflower-blue",
        widths: ["m", "t", "d"],
        url: "http://www.griffith.edu.au/enrich-your-studies",
        click_event: "",
        contents: " <div id='content_div_708404'> Hey {{ userpersonalisation.attributes.NAME }}, find out what activities during your time at Griffith can give you the edge when searching for a job.  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "49239",
        name: "Griffith Research Hub",
        short_name: "Griffith Research Hub",
        audiences: '[{"attr":{"CAREER":["RSCH"]},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-users",
        classname: "shops-cafes-bars",
        color: "yellow",
        widths: ["m", "t", "d"],
        url: "http://research-hub.griffith.edu.au/",
        click_event: "",
        contents: "<a href='#' class='tile__split'>Griffith University's Research Hub, a rich and informative guide to the University's expertise in a comprehensive array of academic fields.</a><a href='#' class='tile__split'>Explore Griffith Research Hub</a> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "211443",
        name: "Don't disappear22!",
        short_name: "HDR Update details",
        audiences: '[{"attr":{"CAREER":["RSCH"],"LIFECYCLE_STATUS":["PS"]},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-user-secret",
        classname: "hdr-graduation",
        color: "orange",
        widths: ["m", "t", "d"],
        url: "{{ links.edit_details_personal_information_iframe }}",
        click_event: "",
        contents: " <div id='content_div_720350'> <p>As one of our soon-to-be <abbr title='Higher degree research'>HDR</abbr> graduates, we are looking forward to following your progress after you leave us. Grow your professional network and stay connected to Griffith by providing a permanent email address before you go.</p> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-graduation-cap orange"



    }
    , {
        id: "49635",
        name: "Grades available",
        short_name: "Grades available",
        audiences: '[{"attr":{"RESULTS":["F"]},"weight":888,"restrict":"Must"},{"attr":{"SRV_INDCTR":["PVAD","PVALL","LPVAD"]},"restrict":"Not"}]',
        linkType: "inner_lightbox",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-paper-plane",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "#",
        click_event: "",
        contents: " <div id='content_div_715190'> <p>Hey {{ userpersonalisation.attributes.NAME }}, see your grades for this trimester!</p>   </div> ",
        lightbox_button_name: "View grades",
        lightbox_title: "My grades",
        lightbox_code: "results",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "50771",
        name: "Grades pending",
        short_name: "Grades pending",
        audiences: '[{"attr":{"RESULTS":["P"]},"weight":887,"restrict":"Must"},{"attr":{"SRV_INDCTR":["PVAD","PVALL","LPVAD"]},"restrict":"Not"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-paper-plane",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/students/assessment-exams-grades/grades",
        click_event: "",
        contents: " <div id='content_div_715190'> <p>Hey {{ userpersonalisation.attributes.NAME }}, grades for your program are yet to be released. Watch this space!</p>   </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "50767",
        name: "Grades withheld",
        short_name: "Grades withheld",
        audiences: '[{"attr":{"RESULTS":["P","F"],"SRV_INDCTR":["PVAD","PVALL","LPVAD"]},"weight":886,"restrict":"Must"},{"attr":{"AFFILIATION":["GELI","GUEST"]},"restrict":"Not"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-paper-plane",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_alerts_service_indicator_iframe }}",
        click_event: "",
        contents: " <div id='content_div_715190'> <p>Hi {{ userpersonalisation.attributes.NAME }}, your grades have been withheld due to outstanding fees or charges.</p>   </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "49625",
        name: "Exam timetable",
        short_name: "Exam timetable - final",
        audiences: '[{"attr":{"FINAL_EXAM_TT":["T"]},"weight":999,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-pencil-square-o",
        classname: "exam-timetable-final",
        color: "blue-grey",
        widths: ["m", "t", "d"],
        url: "#",
        click_event: "",
        contents: " <div id='content_div_715164'> <p>Hi {{ userpersonalisation.attributes.NAME }}, your exam timetable has now been released.</p> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "71417",
        name: "GetReady Maths Quiz",
        short_name: "Get Ready Quiz 1",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"],"PROG_CODE_PRIMARY":"1195,1407,1441,1542,1536,1546,1537,1554,1555,1556,1557,1558,1559,1560,1561,1585"},"weight":991,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-pencil-square-o",
        classname: "shops-cafes-bars",
        color: "cornflower-blue",
        widths: ["m", "t", "d"],
        url: "https://bblearn.griffith.edu.au/webapps/blackboard/content/listContentEditable.jsp?content_id=_2777384_1&course_id=_57661_1",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>Your degree program has assumed prior knowledge for Maths. Complete the GetReady Quiz (not assess able) to see whether there are any areas of Maths you should revise before the start of Trimester. Access may take 24 hours from acceptance.&nbsp;</p>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "71428",
        name: "GetReady Maths and Science Quiz",
        short_name: "Get Ready Quiz 2",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"],"PROG_CODE_PRIMARY":"1564, 1565, 1328, 1018, 1210, 1045, 1571, 1572, 1579, 1512, 1516, 1543, 1547, 1264, 1433, 1330, 1031, 1094, 1306, 1280, 1528, 1529, 1530, 1395, 1355, 1260, 1093, 1493, 1171, 1420, 1421, 1358, 1370"},"weight":991,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-pencil-square-o",
        classname: "shops-cafes-bars",
        color: "cornflower-blue",
        widths: ["m", "t", "d"],
        url: "https://bblearn.griffith.edu.au/webapps/blackboard/content/listContentEditable.jsp?content_id=_2777384_1&course_id=_57662_1",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>Your degree program has assumed prior knowledge for Maths and/or Science. Complete the GetReady Quiz (not assess able) to see whether there are any areas you should revise before the start of Trimester. Access may take 24 hours from acceptance.&nbsp;</p>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "71434",
        name: "GetReady Maths and Biology Quiz",
        short_name: "Get Ready Quiz 3",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"],"PROG_CODE_PRIMARY":"1517"},"weight":991,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-pencil-square-o",
        classname: "shops-cafes-bars",
        color: "cornflower-blue",
        widths: ["m", "t", "d"],
        url: "https://bblearn.griffith.edu.au/webapps/blackboard/content/listContentEditable.jsp?content_id=_2777384_1&course_id=_57663_1",
        click_event: "",
        contents: " <div id='content_div_715230'> <p>Your degree program has assumed prior knowledge for Maths and/or Science. Complete the GetReady Quiz (not assess able) to see whether there are any areas you should revise before the start of Trimester. Access may take 24 hours from acceptance.&nbsp;</p>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "50796",
        name: "Arriving @ GELI",
        short_name: "Arriving @ GELI",
        audiences: '[{"attr":{"AFFILIATION":["GELI"]},"weight":900,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-paper-plane",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/international/griffith-english-language-institute/student-life",
        click_event: "",
        contents: " <div id='content_div_715190'> <p>Hi {{ userpersonalisation.attributes.NAME }}. At GELI we want you to receive the most from your English studies. That is why we have created a wide range of student services to support you in all areas of your GELI experience. </p>   </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "50800",
        name: "GELI Activities",
        short_name: "GELI Activities",
        audiences: '[{"attr":{"AFFILIATION":["GELI"]},"weight":700,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-futbol-o",
        classname: "sport",
        color: "blue-grey-light",
        widths: ["t", "d"],
        url: "https://www.griffith.edu.au/international/griffith-english-language-institute/student-life/activities",
        click_event: "",
        contents: " <div id='content_div_686682'> <p>Social activities can help you experience Australian culture, make new friends and have fun - there are lots of things to do on campus and around Brisbane and the Gold Coast!</p>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-futbol-o blue-grey-light"



    }
    , {
        id: "50788",
        name: "IELTS Test Centre",
        short_name: "IELTS Test Centre",
        audiences: '[{"attr":{"AFFILIATION":["GELI"]},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-pencil-square-o",
        classname: "IELTS Testing",
        color: "orange",
        widths: ["m", "t", "d"],
        url: "http://www.griffith.edu.au/international/griffith-english-language-institute/ielts-testing",
        click_event: "",
        contents: " <div id='content_div_715200'> Find out all about the IELTS test and what to expect on test day.  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "49507",
        name: "myGraduation",
        short_name: "Grad status - Potential graduate",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["NE","PT","UR"]},"weight":666,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-graduation-cap",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_graduation_status_iframe }}",
        click_event: "",
        contents: " <div id='content_div_714407'> <div>   Hi {{ userpersonalisation.attributes.NAME }}. You have been identified for graduation. Please check your myGraduation status now. </div>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-graduation-cap green"



    }
    , {
        id: "50713",
        name: "myGraduation",
        short_name: "Award Graduation Registration",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["AW"]},"weight":777,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-graduation-cap",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_graduation_registration_iframe }}",
        click_event: "",
        contents: " <div id='content_div_722154'> <p>Hi {{userpersonalisation.attributes.NAME}}. You are invited to attend a {{ userpersonalisation.attributes.GRADREG}} ceremony.</p>  <p>Please register between {{userpersonalisation.attributes.REGSTART | date:'dd/MM/yyyy'}} and 5pm {{userpersonalisation.attributes.REGEND | date:'dd/MM/yyyy'}} if you would like to attend a ceremony.</p>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "51172",
        name: "myGraduation",
        short_name: "Appr Graduation Registration",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["AP","CA"]},"weight":777,"restrict":"Must"},{"attr":{"SRV_INDCTR":["TRAN"]},"weight":777,"restrict":"Not"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-graduation-cap",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_graduation_status_iframe }}",
        click_event: "",
        contents: " <div id='content_div_722154'> <div>   <div>     <div>       Hi {{ userpersonalisation.attributes.NAME }}. It looks like you're nearly ready to graduate!     </div>      <div>       Carefully check your name is recorded correctly before it is generated on your graduation documents. Find out more now.     </div>   </div> </div>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "53142",
        name: "myGraduation",
        short_name: "Appr TRAN Graduation Registration",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["AP","CA"]},"weight":777,"restrict":"Must"},{"attr":{"SRV_INDCTR":["TRAN"]},"weight":777,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-graduation-cap",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_graduation_status_iframe }}",
        click_event: "",
        contents: " <div id='content_div_722154'> <div>   <div>     <p>Hi {{ userpersonalisation.attributes.NAME }}. Overdue fees and/or library items are stopping you from seeing your myGraduation status.</p>      <p>You'll be able to see your status within 48 hours of your fees/library items being cleared.</p>   </div> </div>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "50804",
        name: "Graduate success",
        short_name: "Graduate success",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["AP","AW","CA","NE","PS","PT"]},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-briefcase",
        classname: "shops-cafes-bars",
        color: "cornflower-blue",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/careers-employment/students-and-graduates/find-a-job",
        click_event: "",
        contents: " <div id='content_div_722989'> <span style='line-height: 13.5199995040894px;'>Hey {{ userpersonalisation.attributes.NAME }}, find t</span><span style='font-family: arial, sans-serif; font-size: 12.8000001907349px; line-height: normal;'>ips and strategies to manage &nbsp;your graduate job search.</span>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "52782",
        name: "Career Direction",
        short_name: "Career Direction",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"]},"restrict":"Must"},{"attr":{"AFFILIATION":["GELI"]},"restrict":"Not"},{"attr":{"LIFECYCLE_STATUS":["AP","AW","CA","NE","PT","UR"]},"restrict":"Not"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-rocket",
        classname: "shops-cafes-bars",
        color: "coral",
        widths: ["m", "t", "d"],
        url: "https://www.griffith.edu.au/careers-employment",
        click_event: "",
        contents: " <div id='new_div_743786'> Explore where your studies might take you and what sort of career might be right for you! </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "70958",
        name: "Guide to Orientation",
        short_name: "Orientation AHS",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"],"PROG_CODE_PRIMARY":"1171,1420,1421,1355,1400,1493,4157,3050,5269,5320,5578,5567,1587,1589,1579,5706"},"weight":990,"restrict":"Must"},{"attr":{"AVAILABLE_DATE":{"from":null,"to":"2018-07-19T14:00:00.000Z"}},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-compass",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://sites.google.com/a/griffith.edu.au/school-of-allied-health-sciences/",
        click_event: "",
        contents: " <div id='content_div_759972'> <div>   <div>     <p>Welcome to the <strong>School of Allied Health Sciences orientation guide.</strong>&nbsp;</p>      <p>Get details of your School's orientation events, hear from staff and students, and access resources to help your transition to university.</p>   </div> </div>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "no",
        navWidth: "normal",
        navClasses: "fa fa-compass green"



    }
    , {
        id: "53920",
        name: "Guide to Orientation",
        short_name: "Orientation PSY",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"],"PROG_CODE_PRIMARY":"1012,1312,1014,1178,1548,1013"},"weight":990,"restrict":"Must"},{"attr":{"AVAILABLE_DATE":{"from":null,"to":"2018-07-19T14:00:00.000Z"}},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-compass",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://sites.google.com/a/griffith.edu.au/school-of-applied-psychology/",
        click_event: "",
        contents: " <div id='content_div_759972'> <div>   <div>     <p>Welcome to the <strong>School of Applied Psychology orientation guide.</strong></p>      <p>Get details of your School's orientation events, hear from staff and students, and access resources to help your transition to university.</p>   </div> </div>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "no",
        navWidth: "normal",
        navClasses: "fa fa-compass green"



    }
    , {
        id: "70964",
        name: "Guide to Orientation",
        short_name: "Orientation DOH",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"],"PROG_CODE_PRIMARY":"1577,1581,1260,1580,5703,5702,5557"},"weight":990,"restrict":"Must"},{"attr":{"AVAILABLE_DATE":{"from":null,"to":"2018-07-19T14:00:00.000Z"}},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-compass",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://sites.google.com/a/griffith.edu.au/school-of-dentistry-and-oral-health/",
        click_event: "",
        contents: " <div id='content_div_759972'> <div>   <div>     <p>Welcome to the <strong>School of Dentistry and Oral Health orientation guide.</strong></p>      <p>Get details of your School's orientation events, hear from staff and students, and access resources to help your transition to university.</p>   </div> </div>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "no",
        navWidth: "normal",
        navClasses: "fa fa-compass green"



    }
    , {
        id: "70968",
        name: "Guide to Orientation",
        short_name: "Orientation HSV (Internal)",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"],"PROG_CODE_PRIMARY":"1394,1098,1095,1372,1282,1263,5620,5622"},"weight":990,"restrict":"Must"},{"attr":{"CAMPUS_PRIMARY":["OL","OT"]},"restrict":"Not"},{"attr":{"AVAILABLE_DATE":{"from":null,"to":"2018-07-19T14:00:00.000Z"}},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-compass",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://sites.google.com/a/griffith.edu.au/school-of-human-services-and-social-work/",
        click_event: "",
        contents: " <div id='content_div_759972'> <div><div><p>Welcome to the <strong>School of Human Services and Social Work&nbsp;(ON CAMPUS programs)&nbsp;orientation guide.</strong></p> <p>Get details of your School's orientation events, hear from staff and students, and access resources to help your transition to university.</p></div></div> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "no",
        navWidth: "normal",
        navClasses: "fa fa-compass green"



    }
    , {
        id: "174627",
        name: "Guide to Orientation",
        short_name: "Orientation HSV (External)",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"],"PROG_CODE_PRIMARY":"1394,1095,1372,1263,5621,3295,3272,3232,5604,5625"},"weight":990,"restrict":"Must"},{"attr":{"CAMPUS_PRIMARY":["OL","OT"]},"restrict":"Must"},{"attr":{"AVAILABLE_DATE":{"from":null,"to":"2018-07-19T14:00:00.000Z"}},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-compass",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://sites.google.com/a/griffith.edu.au/school-of-human-services-and-social-work-external/",
        click_event: "",
        contents: " <div id='content_div_759972'> <div><div><p>Welcome to the <strong>School of Human Services and Social Work&nbsp;(EXTERNAL programs)&nbsp;orientation guide.</strong></p> <p>Get details of your School's orientation events, hear from staff and students, and access resources to help your transition to university.</p></div></div> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "no",
        navWidth: "normal",
        navClasses: "fa fa-compass green"



    }
    , {
        id: "70962",
        name: "Guide to Orientation",
        short_name: "Orientation MSC",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"],"PROG_CODE_PRIMARY":"1094,1093,1280,1370,2100"},"weight":990,"restrict":"Must"},{"attr":{"AVAILABLE_DATE":{"from":null,"to":"2018-07-19T14:00:00.000Z"}},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-compass",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://sites.google.com/a/griffith.edu.au/school-of-medical-science/",
        click_event: "",
        contents: " <div id='content_div_759972'> <div>   <div>     <p>Welcome to the <strong>School of Medical Science Orientation Guide.</strong>&nbsp;</p>      <p>Get details of your School's orientation events, hear from staff and students, and access resources to help your transition to university.</p>   </div> </div>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "no",
        navWidth: "normal",
        navClasses: "fa fa-compass green"



    }
    , {
        id: "56351",
        name: "Guide to Orientation",
        short_name: "Orientation MED",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"],"PROG_CODE_PRIMARY":"1440,1533"},"weight":990,"restrict":"Must"},{"attr":{"AVAILABLE_DATE":{"from":null,"to":"2018-07-19T14:00:00.000Z"}},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-compass",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://sites.google.com/a/griffith.edu.au/school-of-medicine/",
        click_event: "",
        contents: " <div id='content_div_759972'> <div>   <div>     <p>Welcome to the <strong>School of Medicine orientation guide.</strong>&nbsp;</p>      <p>Get details of your School's orientation events, hear from staff and students, and access resources to help your transition to university.</p>   </div> </div>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "no",
        navWidth: "normal",
        navClasses: "fa fa-compass green"



    }
    , {
        id: "70972",
        name: "Guide to Orientation",
        short_name: "Orientation PHM",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"],"PROG_CODE_PRIMARY":"1395,1528,1529,1530,5661"},"weight":990,"restrict":"Must"},{"attr":{"AVAILABLE_DATE":{"from":null,"to":"2018-07-19T14:00:00.000Z"}},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-compass",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://sites.google.com/a/griffith.edu.au/school-of-pharmacy/",
        click_event: "",
        contents: " <div id='content_div_759972'> <div><div><p>Welcome to the <strong>School of Pharmacy and Pharmacology orientation guide.</strong></p> <p>Get details of your School's orientation events, hear from staff and students, and access resources to help your transition to university.</p></div></div> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "no",
        navWidth: "normal",
        navClasses: "fa fa-compass green"



    }
    , {
        id: "56355",
        name: "Guide to Orientation",
        short_name: "Orientation NRS",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"],"PROG_CODE_PRIMARY":"1162,1165,1161,1354,3347"},"weight":990,"restrict":"Must"},{"attr":{"AVAILABLE_DATE":{"from":null,"to":"2018-07-19T14:00:00.000Z"}},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-compass",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://sites.google.com/a/griffith.edu.au/nursing-and-midwifery-orientation/",
        click_event: "",
        contents: " <div id='content_div_759972'> <div>   <div>     <p>Welcome to the <strong>School of Nursing and Midwifery orientation guide.</strong></p>      <p>Get details of your School's orientation events, hear from staff and students, and access resources to help your transition to university.</p>   </div> </div>  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "no",
        navWidth: "normal",
        navClasses: "fa fa-compass green"



    }
    , {
        id: "174567",
        name: "Guide to Orientation",
        short_name: "Orientation NRS Online",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"],"PROG_CODE_PRIMARY":"3310,5655,3289,5596,3290,5597,3293,5600,3291,5598,3343"},"weight":990,"restrict":"Must"},{"attr":{"AVAILABLE_DATE":{"from":null,"to":"2018-07-19T14:00:00.000Z"}},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: true,
        hasIcon: true,
        tileIconClass: "fa fa-compass",
        classname: "shops-cafes-bars",
        color: "green",
        widths: ["m", "t", "d"],
        url: "https://sites.google.com/a/griffith.edu.au/school-of-nursing-and-midwifery-online/",
        click_event: "",
        contents: " <div id='content_div_759972'> <div><div><p>Welcome to the <strong>School of Nursing and Midwifery&nbsp;(ONLINE programs)&nbsp;orientation guide.</strong></p> <p>Get access to your School's orientation website, hear from staff and students, and access resources to help your transition to university.</p></div></div> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "no",
        navWidth: "normal",
        navClasses: "fa fa-compass green"



    }
    , {
        id: "67865",
        name: "Enhance your LinkedIn profile",
        short_name: "Enhance your LinkedIn profile ",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["AP","AW","CA"]},"weight":250,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-linkedin-square",
        classname: "shops-cafes-bars",
        color: "blue-grey",
        widths: ["m", "t", "d"],
        url: "http://griffith.edu.au/get-linkedin",
        click_event: "",
        contents: " <div id='content_div_882570'> Maximise your employability with a professional LinkedIn Profile,&nbsp;an optimised LinkedIn profile is more likely to be viewed by recruiters.  </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "235078",
        name: "Order your Student ID card",
        short_name: "Order your Student ID card",
        audiences: '[{"attr":{"LIFECYCLE_STATUS":["CM"]},"weight":999,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-credit-card",
        classname: "student-id-card",
        color: "yellow",
        widths: ["m", "t", "d"],
        url: "https://auth.griffith.edu.au/idp/startSSO.ping?PartnerSpId=https://www.idmobile.com.au/captureme",
        click_event: "",
        contents: " <div id='content_div_732730'> <p>Upload your photo online then collect your ID card from your nearest campus.</p> </div> ",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-credit-card yellow"



    }
    , {
        id: "179252",
        name: "Orientation Status",
        short_name: "Orientation Status",
        audiences: '[{"attr":{"ORIENTATION_ACCESS":["T"]},"weight":995,"restrict":"Must"}]',
        linkType: "inner",
        headingLink: false,
        hasIcon: false,
        tileIconClass: "fa fa-coffee",
        classname: "shops-cafes-bars",
        color: "green-bright",
        widths: ["m", "t", "d"],
        url: "#",
        click_event: "",
        contents: " <div class='tile__contents_orientation'>     <div class='o-progress-copy'>         <span>You've completed <span class='percent'></span></span>                            <a href='{{links.orientation_homepage_prod}}'>Continue myOrientation</a>                          </div>     <div class='o-progress-pie'>         <div class='o-complete-pie'>             <svg class='o-complete-pie__svg' viewBox='0 0 32 32'>                 <circle class='o-complete-pie__bg-medium' r='13.5' cx='16' cy='16' />                 <circle class='o-complete-pie__bg-small ' r='8.5' cx='16' cy='16' />                 <circle class='o-complete-pie__fill o-complete-pie__fill-large' r='16' cx='16' cy='16' />                 <circle class='o-complete-pie__fill o-complete-pie__fill-medium' r='16' cx='16' cy='16' />                 <circle class='o-complete-pie__fill o-complete-pie__fill-small' r='16' cx='16' cy='16' />             </svg>             <div class='o-complete-pie__counter'>                 <span class='o-complete-pie__count'>0</span>                 <span>%</span>             </div>             <div class='o-complete-pie__complete-text'>                 <span>complete</span>             </div>         </div>     </div> </div>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "372685",
        name: "Enrolment {{userpersonalisation.attributes.PLAN_TERM}}",
        short_name: "Enrolment: Preplanning (PEQ outstanding)",
        audiences: '[{"attr":{"PLAN_TILE":true,"PLAN_STRT":"future","ENRLMT_APMNT_STRT":"future","PEQ":true},"weight":999,"restrict":"Must"},{"attr":{"PLAN_TERM":"3198"},"restrict":"Not"},{"attr":{"PLAN_TERM":"3201"},"restrict":"Not"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_pre_enrolment_questionnaire_iframe }}",
        click_event: "",
        contents: "<p>Save time<span style='line-height: 1.3;'> by completing your pre-enrolment questionnaire!</span></p><p><strong>Plan</strong> your timetable from {{ renderDate(userpersonalisation.attributes.PLAN_STRT) }}<br /><strong>Save</strong> your plan for enrolment day.<br /><strong>Enrol</strong> from {{renderDate(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }} at {{renderTileTime(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }}</p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "372702",
        name: "Enrolment {{userpersonalisation.attributes.PLAN_TERM}}",
        short_name: "Enrolment: Preplanning",
        audiences: '[{"attr":{"PLAN_TILE":true,"PLAN_STRT":"future","ENRLMT_APMNT_STRT":"future","PEQ":false},"weight":999,"restrict":"Must"},{"attr":{"PLAN_TERM":"3198"},"restrict":"Not"},{"attr":{"PLAN_TERM":"3201"},"restrict":"Not"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_enrolment_planning }}",
        click_event: "",
        contents: "<p id='308413'><strong style='line-height: 1.3;'>Plan</strong> your&nbsp;<span style='line-height: 1.3;'>timetable from {{ renderDate(userpersonalisation.attributes.PLAN_STRT) }}</span></p><p><strong style='line-height: 1.3;'>Save</strong><span style='line-height: 1.3;'> your plan for enrolment day&nbsp;</span></p><p><strong>Enrol</strong> from&nbsp;<span style='line-height: 18.7777786254883px;'>{{renderDate(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }} at&nbsp;</span><span style='line-height: 13.52px;'>{{renderTileTime(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }}</span></p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "672514",
        name: "Planning is open for {{userpersonalisation.attributes.PLAN_TERM}}",
        short_name: "Enrolment: Planning open (PEQ outstanding)",
        audiences: '[{"attr":{"PLAN_TILE":true,"PLAN_STRT":"past","ENRLMT_APMNT_STRT":"future","PEQ":true},"weight":999,"restrict":"Must"},{"attr":{"PLAN_TERM":"3198"},"restrict":"Not"},{"attr":{"PLAN_TERM":"3201"},"restrict":"Not"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_pre_enrolment_questionnaire_iframe }}",
        click_event: "",
        contents: "<p><span style='line-height: 1.3;'>Enrol in {{userpersonalisation.attributes.PLAN_TERM}} from {{renderDate(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }} at {{renderTileTime(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }}</span></p><p><span style='line-height: 1.3;'>You may plan your classes now, before enrolment opens. Remember to complete your pre-enrolment questionnaire before you enrol.</span></p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "372676",
        name: "Planning is open for {{userpersonalisation.attributes.PLAN_TERM}}",
        short_name: "Enrolment: Planning open",
        audiences: '[{"attr":{"PLAN_TILE":true,"PLAN_STRT":"past","ENRLMT_APMNT_STRT":"future","PEQ":false},"weight":999,"restrict":"Must"},{"attr":{"PLAN_TERM":"3198"},"restrict":"Not"},{"attr":{"PLAN_TERM":"3201"},"restrict":"Not"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_enrolment_planning }}",
        click_event: "",
        contents: "<p><span style='line-height: 1.3;'>Enrol in {{userpersonalisation.attributes.PLAN_TERM}} from {{renderDate(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }} at {{renderTileTime(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }}</span></p><p><span style='line-height: 1.3;'>You may plan your classes now, before enrolment opens.</span></p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "372559",
        name: "Enrolment {{userpersonalisation.attributes.PLAN_TERM}}",
        short_name: "Enrolment: Enrolment open (PEQ outstanding)",
        audiences: '[{"attr":{"PLAN_TILE":true,"PLAN_STRT":"past","ENRLMT_APMNT_STRT":"past","PEQ":true},"weight":999,"restrict":"Must"},{"attr":{"PLAN_TERM":"3198"},"restrict":"Not"},{"attr":{"PLAN_TERM":"3201"},"restrict":"Not"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_pre_enrolment_questionnaire_iframe }}",
        click_event: "",
        contents: "<p>Hi {{ userpersonalisation.attributes.NAME }}, enrolment is now open.</p><p>Remember to complete your pre-enrolment questionnaire before you enrol.</p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "557398",
        name: "Enrolment {{userpersonalisation.attributes.PLAN_TERM}}",
        short_name: "Enrolment: Enrolment open",
        audiences: '[{"attr":{"PLAN_TILE":true,"PLAN_STRT":"past","ENRLMT_APMNT_STRT":"past","PEQ":false},"weight":999,"restrict":"Must"},{"attr":{"PLAN_TERM":"3198"},"restrict":"Not"},{"attr":{"PLAN_TERM":"3201"},"restrict":"Not"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_enrolment_planning }}",
        click_event: "",
        contents: "<p>Hi {{ userpersonalisation.attributes.NAME }}, enrolment is now open.</p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "872447",
        name: "Enrolment Trimester 3 2019",
        short_name: "Enrolment Alt T3: Enrolment open (PEQ outstanding)",
        audiences: '[{"attr":{"PLAN_TILE":true,"PEQ":true,"PLAN_TERM":"3198"},"weight":999,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_pre_enrolment_questionnaire_iframe }}",
        click_event: "",
        contents: "<p>Hi {{ userpersonalisation.attributes.NAME }}, enrolment is now open.</p><p>Remember to complete your pre-enrolment questionnaire before you enrol.</p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "872453",
        name: "Enrolment Trimester 3 2019",
        short_name: "Enrolment Alt T3: Enrolment open",
        audiences: '[{"attr":{"PLAN_TILE":true,"PEQ":false,"PLAN_TERM":"3198"},"weight":999,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_enrolment_planning }}",
        click_event: "",
        contents: "<p>Hi {{ userpersonalisation.attributes.NAME }}, enrolment is now open.</p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "872457",
        name: "Enrolment Trimester 1 2020",
        short_name: "Enrolment Alt T1: Preplanning (PEQ outstanding)",
        audiences: '[{"attr":{"PLAN_TILE":true,"PLAN_STRT":"future","ENRLMT_APMNT_STRT":"future","PEQ":true,"PLAN_TERM":"3201"},"weight":999,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_pre_enrolment_questionnaire_iframe }}",
        click_event: "",
        contents: "<p>Save time<span style='line-height: 1.3;'> by completing your pre-enrolment questionnaire!</span></p><p><strong>Plan</strong> your timetable from {{ renderDate(userpersonalisation.attributes.PLAN_STRT) }}<br /><strong>Save</strong> your plan for enrolment day.<br /><strong>Enrol</strong> from {{renderDate(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }} at {{renderTileTime(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }}</p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "872461",
        name: "Enrolment Trimester 1 2020",
        short_name: "Enrolment Alt T1: Preplanning",
        audiences: '[{"attr":{"PLAN_TILE":true,"PLAN_STRT":"future","ENRLMT_APMNT_STRT":"future","PEQ":false,"PLAN_TERM":"3201"},"weight":999,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_enrolment_planning }}",
        click_event: "",
        contents: "<p id='308413'><strong style='line-height: 1.3;'>Plan</strong> your&nbsp;<span style='line-height: 1.3;'>timetable from {{ renderDate(userpersonalisation.attributes.PLAN_STRT) }}</span></p><p><strong style='line-height: 1.3;'>Save</strong><span style='line-height: 1.3;'> your plan for enrolment day&nbsp;</span></p><p><strong>Enrol</strong> from&nbsp;<span style='line-height: 18.7777786254883px;'>{{renderDate(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }} at&nbsp;</span><span style='line-height: 13.52px;'>{{renderTileTime(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }}</span></p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "872465",
        name: "Planning is open for Trimester 1 2020",
        short_name: "Enrolment Alt T1: Planning open (PEQ outstanding)",
        audiences: '[{"attr":{"PLAN_TILE":true,"PLAN_STRT":"past","ENRLMT_APMNT_STRT":"future","PEQ":true,"PLAN_TERM":"3201"},"weight":999,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_pre_enrolment_questionnaire_iframe }}",
        click_event: "",
        contents: "<p><span style='line-height: 1.3;'>Enrol in Trimester 1 2020 from {{renderDate(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }} at {{renderTileTime(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }}</span></p><p><span style='line-height: 1.3;'>You may plan your classes now, before enrolment opens. Remember to complete your pre-enrolment questionnaire before you enrol.</span></p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "872471",
        name: "Planning is open for Trimester 1 2020",
        short_name: "Enrolment Alt T1: Planning open",
        audiences: '[{"attr":{"PLAN_TILE":true,"PLAN_STRT":"past","ENRLMT_APMNT_STRT":"future","PEQ":false,"PLAN_TERM":"3201"},"weight":999,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_enrolment_planning }}",
        click_event: "",
        contents: "<p style='border: 0px'>Enrol in Trimester 1 2020 from {{renderDate(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }} at {{renderTileTime(userpersonalisation.attributes.ENRLMT_APMNT_STRT) }}</p><p style='border: 0px'>You may plan your classes now, before enrolment opens.</p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "872476",
        name: "Enrolment Trimester 1 2020",
        short_name: "Enrolment Alt T1: Enrolment open (PEQ outstanding)",
        audiences: '[{"attr":{"PLAN_TILE":true,"PLAN_STRT":"past","ENRLMT_APMNT_STRT":"past","PEQ":true,"PLAN_TERM":"3201"},"weight":999,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_pre_enrolment_questionnaire_iframe }}",
        click_event: "",
        contents: "<p>Hi {{ userpersonalisation.attributes.NAME }}, enrolment is now open.</p><p>Remember to complete your pre-enrolment questionnaire before you enrol.</p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "872481",
        name: "Enrolment Trimester 1 2020",
        short_name: "Enrolment Alt T1: Enrolment open",
        audiences: '[{"attr":{"PLAN_TILE":true,"PLAN_STRT":"past","ENRLMT_APMNT_STRT":"past","PEQ":false,"PLAN_TERM":"3201"},"weight":999,"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-list-ol",
        classname: "shops-cafes-bars",
        color: "salmon",
        widths: ["m", "t", "d"],
        url: "{{ links.home_my_program_enrolment_planning }}",
        click_event: "",
        contents: "<p>Hi {{ userpersonalisation.attributes.NAME }}, enrolment is now open.</p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "yes",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }
    , {
        id: "794169",
        name: "Bachelor of Science",
        short_name: "Bachelor of Science",
        audiences: '[{"attr":{"PROG_CODE_PRIMARY":"1210"},"restrict":"Must"},{"attr":{"AVAILABLE_DATE":{"from":"2019-07-07T14:00:00.000Z","to":"2100-01-01T00:00:00.000Z"}},"restrict":"Must"}]',
        linkType: "outer",
        headingLink: false,
        hasIcon: true,
        tileIconClass: "fa fa-stethoscope",
        classname: "shops-cafes-bars",
        color: "blue-grey-light",
        widths: ["m", "t", "d"],
        url: "https://bblearn.griffith.edu.au/webapps/blackboard/execute/announcement?method=search&context=course_entry&course_id=_69583_1&handle=announcements_entry&mode=view",
        click_event: "",
        contents: "<p>Important information and updates from your Program Director.</p>",
        lightbox_button_name: "",
        lightbox_title: "",
        lightbox_code: "",
        navShow: "no",
        navWidth: "normal",
        navClasses: "fa fa-coffee orange"



    }

]